import React, { FC } from 'react'
import style from './style.module.less'
import { Button, Table } from 'hljd'
import PriceTable from '@components/LocalMerchant/MarketingCenter/ShopProduct/WuDaNew/PriceTable'
import ConsultBtn from '@components/LocalMerchant/MarketingCenter/ShopProduct/WuDaNew/ConsultBtn'
/**
 *  目前所有五大走这个页面的逻辑， 不再区分尊享和旗舰，统一是立即咨询
 *  WuDa目录被废弃， 后续请再涉及到该页面改动删除WuDa目录，避免造成困扰
 *  改版说明: http://jira.hunliji.com/browse/DEV-35235
 * @author  Ta_Mu
 * @date 2021/5/21 10:39
 */
const columns = [
  {
    key: 'func',
    title: '功能对比',
    dataIndex: 'func'
  },
  {
    key: 'basic',
    title: '基础版',
    dataIndex: 'basic'
  },
  {
    key: 'grow',
    title: '成长版',
    dataIndex: 'grow'
  },
  {
    key: 'featured',
    title: '精选版',
    dataIndex: 'featured'
  },
  {
    key: 'consult',
    title: <Button type='primary'>立即咨询</Button>,
    dataIndex: 'consult'
  },
]


const Index: FC = () => {
  return (
      <div className={style.container}>
        <img src='https://qnm.hunliji.com/camel-c6af93c7-6470-4440-914a-1569879c6f16.png' alt='' className={style.img}/>
        <PriceTable/>
        <img src='https://qnm.hunliji.com/camel-b2541f4f-6994-405e-80d5-4a5c02fe8d3f.png' alt='' className={style.img}/>
        <ConsultBtn/>
      </div>
  )
}

export default Index
